export const PIN_REMINDER_DELAY_MS = 30_000;

export const MUTATION_PREFLOW_UUID = 'c94a4349-46b9-446d-97d8-6ec4d39d1687';
